import React, { useEffect, useRef, useState } from 'react';
interface Props {
  children?: any;
  ratio: number; // width divided by height. for 16:9 aspect ratio pass `ratio={16/9}`.
}
const AspectRatioWrapper: React.FC<Props> = ({ children, ratio }: Props) => {
  const AspectRatioRef = useRef(null as any);

  const [useHeight, setUseHeight] = useState(false);
  const [paddingRight, setPaddingRight] = useState(0);

  const handleResize = () => {
    if (
      (parseInt(AspectRatioRef?.current?.clientWidth) || 0) > 0 &&
      (parseInt(AspectRatioRef?.current?.clientHeight) || 0) > 0
    ) {
      const clientRatio =
        AspectRatioRef?.current?.clientWidth / AspectRatioRef?.current?.clientHeight;
      setUseHeight(clientRatio > ratio);
      setPaddingRight(ratio * AspectRatioRef?.current?.clientHeight);
    } else {
      setUseHeight(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      ref={AspectRatioRef}
    >
      <div
        style={
          useHeight
            ? {
                position: 'relative',
                width: '0',
                height: '100%',
                paddingRight: `${paddingRight}px`,
              }
            : {
                position: 'relative',
                width: '100%',
                height: '0',
                paddingBottom: `${(1 / ratio) * 100}%`,
              }
        }
      >
        <div style={{ position: 'absolute', top: '0', right: '0', bottom: '0', left: '0' }}>
          {children}
        </div>
      </div>
    </div>
  );
};
export default AspectRatioWrapper;
